import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexingApiService {
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  getIndexingHistory(pageNo: number, siteId: string, urlFilter: string, statusFilter: any, autoSubmissionFilter: any) {
    if (urlFilter != "")
      return this.httpClient.get(this.baseUrl + 'indexinghistories?pageNo=' + pageNo + "&siteId=" + siteId + "&url=" + urlFilter + "&status=" + statusFilter + "&isAutoSubmitted=" + autoSubmissionFilter);
    else
      return this.httpClient.get(this.baseUrl + 'indexinghistories?pageNo=' + pageNo + "&siteId=" + siteId + "&status=" + statusFilter + "&isAutoSubmitted=" + autoSubmissionFilter);
  }

  batchAddUpdateIndex(siteId: any, urls: string[]) {
    var body = { urls: urls, currentDate: new Date() }
    return this.httpClient.post(this.baseUrl + `indexingapi/BatchAddUpdateIndex/${siteId}`, body);
  }

  addUrlsToAutoIndexQueue(siteId: any, urls: string[]) {
    var body = { urls: urls }
    return this.httpClient.post(this.baseUrl + `autoIndexQueue/${siteId}`, body);
  }

  getGscAccess(fullCheck: boolean) {
    return this.httpClient.get(this.baseUrl + `indexingapi/getGscAccess?fullCheck=${fullCheck}`);
  }

  getAutoIndexQueue(currentPage: number) {
    return this.httpClient.get(this.baseUrl + `autoIndexQueue?pageNo=${currentPage}`);
  }

  createCloudProject(projectNumber: number) {
    return this.httpClient.post(this.baseUrl + `indexingapi/CreateCloudProject/${projectNumber}`, null);
  }
}
